// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { Plan } from "./types";
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  data: Plan;
  notificationID: string | number;
}

export function useCreatePlanMutation(
  onSuccessMutation?: (data: Plan, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function createPlan(params: paramsType): Promise<Plan> {
    const response = await api.post<Plan>("admin/plans", params.data);

    if (!response.ok || !response.data) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: createPlan,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
